import React from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { Grid, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Button, Input } from '../../atoms'

const useStyles = makeStyles(theme => ({
  button: {
    color: theme.palette.common.black,
    padding: '10px 45px',
    borderRadius: '2px',
    fontSize: '0.875rem',
  },
  input: {
    width: '65%',
  },
  label: {
    color: theme.palette.textGrey,
  },
  paddingTop: {
    paddingTop: theme.spacing(1),
  },
}))

const LoginForm = ({ onSubmit, loading }) => {
  const classes = useStyles()
  const { t } = useTranslation('auth')

  const loginSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('invalidEmail'))
      .required(t('required'))
      .transform(value => value.toLowerCase()),
  })

  const methods = useForm({ resolver: yupResolver(loginSchema) })

  const {
    handleSubmit,
    formState: { errors },
    register,
  } = methods
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid xs={12} item>
          <Typography variant="h2">{t('login')}</Typography>
        </Grid>
        <Grid xs={12} item>
          <Input
            {...register('email')}
            label={t('email')}
            error={errors?.email?.message}
            helperText={errors?.email?.message}
            small
            className={classes.input}
            labelClassName={classes.label}
            required
          />
        </Grid>

        <Grid item>
          <Button loading={loading} type="submit" color="primary" className={classes.button}>
            {t('loginAction')}
          </Button>
        </Grid>
        <Grid xs={12} item>
          <Typography variant="body2">{t('mandatoryFields')}</Typography>
        </Grid>
      </Grid>
    </form>
  )
}
LoginForm.propTypes = {
  onSubmit: PropTypes.func,
  loading: PropTypes.bool,
}
LoginForm.defaultProps = {
  onSubmit: () => {},
  loading: false,
}

export default LoginForm
